/* eslint-disable */
import {
  ClampToEdgeWrapping,
  DataTexture,
  LinearFilter,
  MirroredRepeatWrapping,
  PMREMGenerator,
  RepeatWrapping,
  Texture,
  TextureLoader,
  UnsignedByteType,
  WebGLRenderer,
  WebGLRenderTarget,
  Wrapping,
} from 'three';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';
import { useLoadStore } from '../stores/use-load-store';
enum TEX_TYPE {
  TEX,
  RGBE,
}

interface TEX_CONFIG {
  type: TEX_TYPE;
  url: string;
  res: any;
  priority: number;
  wrapS?: Wrapping;
  wrapT?: Wrapping;
  preload?: boolean;
}

class TexManager {
  renderer!: WebGLRenderer;
  texLoader = new TextureLoader();
  hdrRenderTarget!: WebGLRenderTarget;
  texMap: {
    [k: string]: TEX_CONFIG;
  } = {
    noise: {
      url: `${process.env.PUBLIC_URL}/textures/noise4.png`,
      type: TEX_TYPE.TEX,
      res: null,
      wrapS: MirroredRepeatWrapping,
      wrapT: MirroredRepeatWrapping,
      priority: 0,
    },
    localCloud: {
      url: `${process.env.PUBLIC_URL}/textures/localCloud.png`,
      type: TEX_TYPE.TEX,
      res: null,
      wrapS: MirroredRepeatWrapping,
      wrapT: MirroredRepeatWrapping,
      priority: 0,
    },
  };

  constructor() {
    // this.initStoreRes();
  }

  async init(renderer: WebGLRenderer) {
    this.renderer = renderer;
    this.loadPriority(-1);
  }

  async loadPriority(p: number) {
    let list = [];
    let promiseList: Array<Promise<Texture | null>> = [];
    for (const key in this.texMap) {
      const config = this.texMap[key];
      if (config.priority === p || p === -1) {
        list.push(config);
      }
    }

    // 并发加载
    // list.forEach((c) => {
    //   if (c.preload !== false)
    //     promiseList.push(this.loadByType(c));
    // });
    // return Promise.all(promiseList);

    // 队列加载
    for (let i = 0; i < list.length; i++) {
      const c = list[i];
      // console.log(`start load ${c.url}`)
      await this.loadByType(c);
      // console.log("hasload", c.url)
    }
  }

  initStoreRes() {
    for (const key in this.texMap) {
      const config = this.texMap[key];
      if (config.preload !== false) this.updateProgress(config.url, 0);
    }
  }

  loadByType(c: TEX_CONFIG) {
    if (c.type === TEX_TYPE.TEX) return this.loadTex(c);
    else if (c.type === TEX_TYPE.RGBE) return this.loadHDR(c);
    return Promise.resolve(null);
  }

  loadTex(config: TEX_CONFIG) {
    return new Promise<Texture>(res => {
      config.res = this.texLoader.load(config.url, tex => {
        tex.name = config.url;
        config.preload !== false && this.updateProgress(config.url, 1);
        tex.wrapS = config.wrapS ? config.wrapS : RepeatWrapping;
        tex.wrapT = config.wrapT ? config.wrapT : RepeatWrapping;
        tex.magFilter = LinearFilter;
        tex.minFilter = LinearFilter;
        tex.needsUpdate = true;
        // store.state.highVersion && this.renderer.initTexture(tex);
        res(tex);
      });
    });
  }

  loadHDR(config: TEX_CONFIG) {
    return new Promise<Texture>(res => {
      const pmremGenerator = new PMREMGenerator(this.renderer);
      pmremGenerator.compileEquirectangularShader();
      new RGBELoader()
        .setDataType(UnsignedByteType)
        .load(config.url, (hdrEquirect: DataTexture) => {
          config.preload !== false && this.updateProgress(config.url, 1);
          const hdrCubeRenderTarget =
            pmremGenerator.fromEquirectangular(hdrEquirect);
          config.res = hdrCubeRenderTarget.texture;
          config.res.name = config.url;
          // store.state.highVersion && this.renderer.initTexture(config.res);

          hdrEquirect.dispose();
          pmremGenerator.dispose();

          res(hdrCubeRenderTarget.texture);
        });
    });
  }

  updateProgress(id: string, progress: number) {
    // store.commit('UpdateResLoadProgress', { id, progress });

    const updateProgress = useLoadStore.getState().updateProgress;
    updateProgress(id, progress);
  }

  get(id: string): Texture | null {
    const config = this.texMap[id];
    if (config) {
      if (!config.res) this.loadByType(config);
      return config.res;
    }
    return null;
  }
}

export default new TexManager();
